import React from 'react';
import { Grid, Select } from 'semantic-ui-react';
import RefreshSlider from '../shared/RefreshSlider';

class OperationalFiltersFilters extends React.Component {

  render() {

    const { disabled, selectedPeriod, selectedReport, periods, reports, onChange } = this.props;

    return (
        <Grid>
          <Grid.Row>
            <Grid.Column verticalAlign="middle">
              <Select disabled={disabled} options={periods} value={selectedPeriod} name="selectedPeriod" onChange={(event, { name, value }) => onChange(name, value )} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle" width="12">
              <Select disabled={disabled} options={reports} value={selectedReport} name="selectedReport" onChange={(event, { name, value }) => onChange(name, value )} fluid />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle" width="12">
              <RefreshSlider className="mt-1" disabled={!selectedPeriod || !selectedReport} refresh={this.props.onRefreshClick} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
    );
  }
};

export default OperationalFiltersFilters;
